//@flow

import styled from 'styled-components';

import { Flex } from '.';

export default styled(Flex)`
    overflow: auto;
`;
